import Repository from "@shared/services/api/abstracts/Repository";
import { UrlRouteMap, Identifier } from "@shared/services/api/types";
import { venueBasedUrl } from "@shared/services/api/utils/RepositoryUrlUtils";
import { TaskedEndpointResponse } from "@shared/services/loaders/api";
import { VenueBasedEventSerializer, RatingSummaryType } from "../types/events";

export default class VenueBasedEventRepository extends Repository<VenueBasedEventSerializer> {
  public readonly repositoryName = "VenueBasedEventRepository";

  public readonly endpoint = venueBasedUrl("events/");

  public get urlMap(): UrlRouteMap {
    return {
      ...this.defaultUrlMap,
      bulkUpdate: "{id}/bulk-update",
      generateRatingSummary: "{id}/generate-rating-summary",
    };
  }

  public async bulkUpdate(id: Identifier): Promise<TaskedEndpointResponse> {
    const { data } = await this.request<TaskedEndpointResponse>(
      this.buildUrl("bulkUpdate", { id })
    );

    return data;
  }

  public async generateRatingSummary(
    id: Identifier
  ): Promise<{ rating_summary: RatingSummaryType }> {
    const { data } = await this.request<{ rating_summary: RatingSummaryType }>(
      this.buildUrl("generateRatingSummary", { id }),
      { method: "POST" }
    );

    return data;
  }
}
